import React from 'react';
import { 
  Box, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  SelectChangeEvent,
  Chip
} from '@mui/material';
import {
  AdminPanelSettings as AdminIcon,
  LocalHospital as DoctorIcon,
  Person as PatientIcon,
  Visibility as ViewerIcon,
  LocalHospital as CaregiverIcon,
  Warning as EmergencyIcon,
  FamilyRestroom as FamilyIcon,
  LocalHospital as HospitalIcon,
  AirportShuttle as AmbulanceIcon
} from '@mui/icons-material';

interface RoleSwitcherProps {
  currentRole: string;
  onRoleChange: (role: string) => void;
}

const RoleSwitcher: React.FC<RoleSwitcherProps> = ({ currentRole, onRoleChange }) => {
  const handleChange = (event: SelectChangeEvent) => {
    onRoleChange(event.target.value);
  };

  const getRoleIcon = (role: string) => {
    switch (role) {
      case 'admin': return <AdminIcon />;
      case 'doctor': return <DoctorIcon />;
      case 'patient': return <PatientIcon />;
      case 'family_caregiver': return <CaregiverIcon />;
      case 'family_viewer': return <ViewerIcon />;
      case 'family_emergency': return <EmergencyIcon />;
      case 'hospital': return <HospitalIcon />;
      case 'ambulance': return <AmbulanceIcon />;
      default: return null;
    }
  };

  const getRoleColor = (role: string) => {
    switch (role) {
      case 'admin': return 'primary';
      case 'doctor': return 'success';
      case 'patient': return 'info';
      case 'family_caregiver': return 'secondary';
      case 'family_viewer': return 'default';
      case 'family_emergency': return 'error';
      case 'hospital': return 'error';
      case 'ambulance': return 'warning';
      default: return 'default';
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Chip
        icon={getRoleIcon(currentRole)}
        label={
          currentRole === 'admin' ? 'Administrador' : 
          currentRole === 'doctor' ? 'Doctor' : 
          currentRole === 'patient' ? 'Paciente' :
          currentRole === 'family_caregiver' ? 'Familiar - Cuidador' :
          currentRole === 'family_viewer' ? 'Familiar - Observador' :
          currentRole === 'family_emergency' ? 'Familiar - Emergencia' :
          currentRole === 'hospital' ? 'Hospital - Emergencias' :
          currentRole === 'ambulance' ? 'Ambulancia' : ''
        }
        color={getRoleColor(currentRole) as any}
        variant="outlined"
      />
      
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel>Cambiar Vista</InputLabel>
        <Select
          value={currentRole}
          label="Cambiar Vista"
          onChange={handleChange}
        >
          <MenuItem value="admin">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AdminIcon fontSize="small" />
              Administrador
            </Box>
          </MenuItem>
          <MenuItem value="doctor">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <DoctorIcon fontSize="small" />
              Doctor/Responder
            </Box>
          </MenuItem>
          <MenuItem value="patient">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PatientIcon fontSize="small" />
              Paciente
            </Box>
          </MenuItem>
          <MenuItem value="family_caregiver">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FamilyIcon fontSize="small" />
              Familiar - Cuidador
            </Box>
          </MenuItem>
          <MenuItem value="family_viewer">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FamilyIcon fontSize="small" />
              Familiar - Observador
            </Box>
          </MenuItem>
          <MenuItem value="family_emergency">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <FamilyIcon fontSize="small" />
              Familiar - Emergencia
            </Box>
          </MenuItem>
          <MenuItem value="hospital">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <HospitalIcon fontSize="small" />
              Hospital - Emergencias
            </Box>
          </MenuItem>
          <MenuItem value="ambulance">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <AmbulanceIcon fontSize="small" />
              Ambulancia
            </Box>
          </MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default RoleSwitcher;